
import { Component, Prop }        from '$/lib/vueExt';
import { BLink as BLinkOriginal } from 'bootstrap-vue';

/**
 * Overrides for BLink.
 */
@Component
export default class Link extends BLinkOriginal {

	// override the default target to _blank so that by default links open up on new tabs
	@Prop({ default : '_blank' })
	readonly target: string;

	@Prop({ default : 'noreferrer noopener' })
	readonly rel: string;

	@Prop({ default : undefined })
	readonly href: string;

	/**
	 * If provided, this text will be used as the link text.
	 * If both this property and slot contents are provided, the slot contents will take precedence.
	 */
	@Prop({ default : undefined })
	readonly text: string;

	render(h: any) {
		if (this.text !== undefined) {
			this.$slots.default = [ h('span', this.text) ];
		}
		return h(
			'a',
			{
				attrs : { ...this.$attrs, target : this.target, rel : this.rel, href : this.href },
				on    : this.$listeners,
				class : 'text-primary clickable',
			},
			this.$slots.default
		);
	}

}
